// appsignal.js
import Appsignal from "@appsignal/javascript"; // For ES Module
// const Appsignal = require("@appsignal/javascript").default; // For CommonJS module
 
export const appsignal = new Appsignal({
  key: process.env.REACT_APP_APPSIGNAL_API_KEY,
});